import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class FooterWeb extends Component {
    render() {
        return (
            <footer>
            <div className='container-98'>
                <div className='row m-0 footer-top align-items-stretch justify-content-center'>
                    <div className='col-lg-4 col-md-12 col-sm-12 col-12'>
                       <a href="#">
                        <img
                            src={require("../../src/assets/images/website/footerlogo.webp")}
                            alt="Klinicq Footer Logo"
                            className="footerLogo mb-3"
                            width="225"
                            height="100"
                            loading="lazy"
                            fetchPriority="low"
                            decoding="async"
                        />
                        </a>

                        {/* <p>131, Rashtriya Vidyalaya Rd, Vishweshwarapura, <br/>Basavanagudi, Bengaluru, Karnataka 560004</p> */}
                        <p>514 A,Min Nagar, Panickampatti Post <br/>Palladam,Tiruppur,TamilNadu-641664</p>
                     
                          <ul className='social-logo p-0'>
                            
                            <li><a href='https://www.instagram.com/klinicq108/' target='_blank'><img src={require("../../src/assets/images/website/social1.png")} width={24} height={24} /></a></li>
                            <li><a href='https://www.facebook.com/profile.php?id=61573936018380' target='_blank'><img src={require("../../src/assets/images/website/social2.png")} width={24} height={24} /></a></li>
                            <li><a href='https://x.com/KlinicQ108' target='_blank'><img src={require("../../src/assets/images/website/social6.png")} width={24} height={24} /></a></li>
                            <li><a href='https://www.youtube.com/@NucleoSoftwareSolutions' target='_blank'><img src={require("../../src/assets/images/website/social4.png")} width={24} height={24} /></a></li>
                        </ul>
                        <div id="download" class="download-btn2">
                    <a target="_blank" href="https://apps.apple.com/us/app/klinicq-health/id6447692881">
                        <img src={require("../../src/assets/images/website/apple.svg")} alt="Download Klinicq Health app on Apple App Store"/>
                        <span>Download on the</span> App Store
                    </a>
                    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.nucleo.klinicQ&hl=en_IN" class="ml-2">
                        <img src={require("../../src/assets/images/website/android1.png")} alt="Get Klinicq Health app on Google Play Store"/>
                        <span>Get it on</span> Google Play
                    </a>
                    </div>

                      
                    </div>
                    <div className='col-lg-2 col-md-4 col-sm-4 col-6 py-2'>
                        <ul className='footer-list p-0  float-md-none'>
                            <li className='content-title'style={{color:'#0C5B98'}}>Platform</li>
                            <li>
                                <NavLink exact to={{ pathname: '/about-us' }} className='text-decoration-none text-white'>
                                    About Us
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/patient-managment-software' }} className='text-decoration-none text-white'>
                                    For Patient
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/doctor-managment-software' }} className='text-decoration-none text-white'>
                                For Doctor
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/hospital-managment-software' }} className='text-decoration-none text-white'>
                                    For Hospital
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/pharmacy-managment-software' }} className='text-decoration-none text-white'>
                                    For Pharmacy
                                </NavLink>
                            </li>
                           
                          
                        </ul>
                    </div>
                    
                    <div className='col-lg-2 col-md-4 col-sm-4 col-6 py-3'>
                        <ul className='footer-list p-0  float-md-none'>
                            <li className='content-title'style={{color:'#0C5B98'}}>Company</li>
                           
                            <li>
                                <NavLink exact to={{ pathname: '/contact' }} className='text-decoration-none text-white'>
                                Careers 
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/contact' }} className='text-decoration-none text-white'>
                                Contact Us
                                </NavLink>
                            </li>
                           
                            <li>
                                <a
                                    href="/terms"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none text-white"
                                >
                                    Terms of Service
                                </a>
                            </li>
                           
                            <li>
                                <a
                                    href="/privacy_policy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none text-white"
                                >
                                    Privacy and Policy
                                </a>
                            </li>
                            <li>
                                <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                                Cookies
                                </NavLink>
                            </li>
                           
                        </ul>
                    </div>

                    <div className='col-lg-2 col-md-4 col-sm-4 col-6 py-3'>
        <ul className='footer-list p-0 float-md-none'>
            <li className='content-title' style={{ color: '#0C5B98' }}>ContactUs</li>
          
            <li>
                <span className='text-white'><a href='/contact' className='text-decoration-none text-white'>info@nucleosws.com</a></span>
            </li>
          
            <li>
                <span className='text-white'><a href='/contact' className='text-decoration-none text-white' target='_blank' rel='noopener noreferrer' >Sales:+91 8015774643</a></span>
            </li>
        </ul>
    </div>

                    {/* <div className='row'>  */}
        <div className='col-lg-2 col-md-4 col-sm-4 col-6 py-3'>
            <ul className='footer-list p-0 float-md-none'>
                <li className='content-title' style={{ color: '#0C5B98' }}>Media</li>
                <li>
                    <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                        Blogs
                    </NavLink>
                </li>
                <li>
                    <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                        Documentation
                    </NavLink>
                </li>
                <li>
                    <NavLink exact to={{ pathname: '/' }} className='text-decoration-none text-white'>
                        Paperless
                    </NavLink>
                </li>
               
            </ul>
        </div>
    {/* </div> */}
    <div className='row'>
    
    </div>
                  
                </div>
            </div>
            <div className='footer-bottom-layout1'>
            <div className='container-95'>
               
                <div className='col-lg-12 col-12 text-lg-end text-center'>
                <a href='#' className='text-decoration-none text-white'>
                    <p className="mb-0 py-3">
                    Copyright © {new Date().getFullYear()}, Nucleo Software Solutions. All rights reserved.
                    </p>
                </a>
                </div>

            </div>
            </div>
          
        </footer>
        )}};
        export default FooterWeb;
       